<template>
  <div class="content">
    <OreLavoro>
    </OreLavoro>
  </div>
</template>

<script>
  import OreLavoro from './OreLavoro.vue'
  
  export default {
    components: {
      OreLavoro
    },
    data () {
      return {
      }
    },
    computed: {
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Home.vue